import * as v from 'valibot'

export type Announcement = v.InferOutput<typeof AnnouncementSchema>
export const AnnouncementSchema = v.object({
  buttonType: v.picklist(['OK', 'OK_CANCEL']),
  message: v.string(),
  subject: v.optional(v.string()),
  type: v.optional(
    v.picklist([
      'Announcement',
      'Reminder',
      'Activation_TOA', // special type of announcement, used for ToA message
      'Disabled', // special type of announcement, used for message about subscription expiration
      'Suspended', // special type of announcement, used for message about account or device suspension
      'Pending', // special type of announcement, used for message about subscription approval pending
    ])
  ),
})

export type Tokens = v.InferOutput<typeof TokensSchema>
export const TokensSchema = v.record(v.string(), v.string())

export type AnnouncementList = v.InferOutput<typeof AnnouncementListSchema>
export const AnnouncementListSchema = v.object({
  announcements: v.array(AnnouncementSchema),
  tokens: v.optional(TokensSchema, {}),
})
